import {ReactElement} from 'react';
import {SearchResult} from '../schema';


type handleClickWord = (_: any) => void;


export const highlight = (text: string, key: number, handler: handleClickWord, color: string, location?: string): ReactElement<HTMLDivElement> => (
  <span key={key}>
    {text.split(/[{}]{2}/).map((each, eachkey) => {
      const eachColor = location === each ? 'text-yellow-500' : color;
      return (eachkey % 2 === 1) ?
        <button
          key={eachkey}
          onClick={() => handler(each)}
          className={`btn-none ${eachColor}`}
        >
          {strong(each, eachkey)}
        </button>:
        <span key={eachkey}>{strong(each, eachkey)}</span>;
    })}
  </span>
);


const strong = (rawText: string, key: number): ReactElement<HTMLSpanElement> => (
  <span key={key}>
    {rawText
        .replace(/<\/em><em>/g, '')
        .split(/<\/?em>/)
        .map((each: string, eachKey: number) => (
            eachKey % 2 == 0 ?
              <span key={eachKey}>{each}</span> :
              <span key={eachKey} className='font-bold'>{each}</span>
        ))
    }
  </span>
);


interface LngLat {x: number, y: number};
const lnglatToKm = (begin: LngLat, dist: LngLat): number => {
  const rad = (deg: number) => (deg / 180 * Math.PI);
  const start = {x: rad(begin.x), y: rad(begin.y)};
  const end = {x: rad(dist.x), y: rad(dist.y)};
  const r = 6378.137;
  const dx = end.x - start.x;
  const v = Math.sin(start.y) * Math.sin(end.y);
  const h = Math.cos(start.y) * Math.cos(end.y) * Math.cos(dx);
  return r * Math.acos(v + h);
};


export const addEmTag = (eachResult: SearchResult): string => {
  let text = eachResult.text;
  eachResult.hl
      .replace(/<\/em><em>/g, '')
      .split(/<\/?em>/)
      .map((eachHl, hlKey) => (hlKey % 2 !== 0) ? eachHl : undefined)
      .filter((eachHl) => eachHl)
      .map((eachHl) => {
        if (eachHl === undefined) return;
        const re = new RegExp(eachHl, 'g');
        text = text.replace(re, `<em>${eachHl}</em>`);
      });
  return text;
};


export const score = (
    result: SearchResult,
    lnglat: [number, number],
): SearchResult => {
  const [x, y] = lnglat;
  const sortedFeatures = result.geojson.sort((a, b) => {
    const [ax, ay] = a.geometry.coordinates;
    const aDist = Math.sqrt((x - ax)**2 + (y - ay)**2);
    const [bx, by] = b.geometry.coordinates;
    const bDist = Math.sqrt((x - bx)**2 + (y - by)**2);
    return aDist - bDist;
  });
  const solrScore = result.score;
  const text = addEmTag(result);
  if (sortedFeatures.length > 0) {
    const nearestFeature = sortedFeatures[0];
    const zindex = text.search(nearestFeature.properties.label);
    const nearest = text.slice(zindex - 50, zindex + 50);
    const [nx, ny] = nearestFeature.geometry.coordinates;
    const distance = lnglatToKm({x: nx, y: ny}, {x, y});
    const spartialScore = -distance;
    return {...result, score: spartialScore, distance, solrScore, text, nearest};
  } else {
    return {...result, score: -40000, distance: NaN, solrScore, text};
  }
};

export const filterResults = (
    results: SearchResult[], lngRange: [number, number], latRange: [number, number],
): SearchResult[] => {
  return results.filter((each) => {
    let isIn = false;
    each.geojson.forEach((feature) => {
      const [lng, lat] = feature.geometry.coordinates;
      isIn = isIn ||
        (lngRange[1] <= lng && lng <= lngRange[0]) &&
        (latRange[1] <= lat && lat <= latRange[0]);
    });
    return isIn;
  });
};
